<template>
  <div class="content-category">
    <div>
      <form @submit.prevent="searchCategory">
        <input name="seachCategory" v-model="seachCategory" type="input" class="base-input" :placeholder="$t('search_category')" />
      </form>
    </div>
    <div class="filter">
      <p class="title">{{$t('filtered_by')}}</p>
      <li class="radio">
        <div class="radio-item">
          <input id="default_category" name="radio" type="radio" value="" @change="onChangeFilterCategory" v-model="checkedFilter"/>
          <label for="default_category" class="radio-label" @change="onChangeFilterCategory">{{$t('all_category')}}</label>
        </div>
        <div class="radio-item">
          <input id="parent_category" name="radio" type="radio" value="parent" @change="onChangeFilterCategory" v-model="checkedFilter"/>
          <label for="parent_category" class="radio-label" @change="onChangeFilterCategory">{{$t('parent_category')}}</label>
        </div>
        <div class="radio-item">
          <input id="child_category" name="radio" type="radio" value="child" @change="onChangeFilterCategory" v-model="checkedFilter"/>
          <label for="child_category" class="radio-label" @change="onChangeFilterCategory">{{$t('child_category')}}</label>
        </div>
      </li>
    </div>
    <div class="category-list" @scroll="handleScroll" id="category-list">
      <p class="title">{{$t('category_list')}}</p>
      <div class="checkbox">
        <input type="checkbox" id="checkbox" @change="onSelectAllCategories" v-model="isSelectAllCategories"/>
        <label for="checkbox">{{ $t("all_categories") }}</label>
      </div>
      <div v-if="!getLoadingFilterCategories">
        <treeselect
          v-model="value"
          :multiple="true"
          :options="listCatalogFilter.data"
          :normalizer="normalizer"
          :value-consists-of="valueConsistsOf"
          :alwaysOpen="true"
          :searchable="false"
          :flat="true"
        >
        </treeselect>
      </div>
      <div v-else class="loading-filter">
        {{$t('loading')}}...
      </div>

    </div>
    <div class="bottom-buttom">
      <button class="btn" @click="handleResetCategoriesFilter">{{$t('reset')}}</button>
      <button class="btn btn-apply" @click="handleApplyCategoriesFilter">{{$t('apply')}}</button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  name: 'FilterWeeks',
  components: {
    Treeselect
  },
  data () {
    return {
      value: null,
      isSelectAllCategories: false,
      valueConsistsOf: 'ALL',
      seachCategory: '',
      checkedFilter: '',
      normalizer (node) {
        return {
          id: node.id,
          label: node.name,
          children: node.children
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      listCatalogFilter: 'catalog/getListCatalogFilter',
      reportQuery: 'report/getQuery',
      getLoadingFilterCategories: 'catalog/getLoadingFilterCategories'
    })
  },
  mounted () {
    window.addEventListener('scroll', this.handleDebouncedScroll)
  },
  created () {
    if (this.listCatalogFilter.data && this.listCatalogFilter.data.length >= 1 && this.listCatalogFilter.data[0].length === 0) {
      this.listCatalogFilter.data = []
    }
    this.seachCategory = ''
    this.getCategoriesFilter({
      query: { ...this.reportQuery, page: 1, limit: 30, filterBy: '' }
    }).then(() => {
      if (this.reportQuery && (this.reportQuery.categoryIds || '').toString() !== '') {
        this.value = (this.reportQuery.categoryIds || '').split(',').map((e) => {
          if (e !== '') {
            return e
          }
        })
      }
    })
    if (this.reportQuery && (this.reportQuery.filterBy || '') !== '') {
      this.checkedFilter = this.reportQuery.filterBy || ''
    }
  },
  methods: {
    ...mapActions({
      getCategoriesFilter: 'catalog/getCategoriesFilter',
      getReport: 'report/getReportDataByStore'
    }),
    handleScroll ({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (scrollTop + clientHeight >= scrollHeight && this.listCatalogFilter.currentPage < this.listCatalogFilter.maxPage) {
        this.getCategoriesFilter({
          query: { ...this.reportQuery, page: this.listCatalogFilter.currentPage + 1, limit: 30 }
        })
      }
    },
    onSelectAllCategories (e) {
      if (this.isSelectAllCategories) {
        this.value = this.listCatalogFilter.data.filter((e) => !(e.isDisabled || false)).map((e) => e.id)
      } else {
        this.value = null
      }
    },
    onChangeFilterCategory (e) {
      this.value = null
      this.seachCategory = ''
      this.checkedFilter = e.target.value || ''
      this.getCategoriesFilter({
        query: { ...this.reportQuery, page: 1, limit: 30, filterBy: e.target.value || '' }
      })
    },
    handleApplyCategoriesFilter () {
      if (this.isSelectAllCategories) {
        this.value = []
      }
      this.$emit('onFilterCategory', (this.value || []).toString(), this.checkedFilter)
    },
    handleResetCategoriesFilter () {
      this.value = null
      this.isSelectAllCategories = ''
      this.seachCategory = ''
      this.checkedFilter = ''
      this.getCategoriesFilter({
        query: { ...this.reportQuery, page: 1, limit: 30, filterBy: '' }
      })
    },
    searchCategory (e) {
      this.value = null
      this.getCategoriesFilter({
        query: { ...this.reportQuery, page: 1, limit: 30, filterBy: e.target.value || '', search: this.seachCategory || '' }
      })
    }
  }
}
</script>

<style lang="scss">
  .content-category {
    padding: 20px;
    .title {
      padding: 10px 0;
      font-weight: 600;
      color: #818181;
    }
    .checkbox {
      padding: 0 0 5px 0;
      label {
       margin-left: 5px;
      }
    }
    .filter, .category-list {
      display: flex;
      flex-direction: column;
      text-align: left;
      font-size: 16px;
      .radio {
        list-style: none;
        color: #575757;
        margin: 0;
        .radio-item {
          display: flex;
          flex-direction: row;
          padding: 5px 0;
          .radio-label:before {
            width: 0.9em;
            height: 0.9em;
            top: 0;
          }
        }
      }
    }
    .category-list {
      min-height: 320px;
      overflow: scroll;
      scroll-behavior: smooth;
      margin-bottom: 30px;
      min-width: 287px;
      .loading-filter {
        display: flex;
        justify-content: center;
        height: 320px;
        align-items: center;
        opacity: 0.7;
      }
      .vue-treeselect__control {
        display: none;
      }
      .vue-treeselect, .vue-treeselect--multi, .vue-treeselect--open, .vue-treeselect--open-below {
        background-color: transparent;
      }
      .vue-treeselect--open-below .vue-treeselect__menu {
        background: none;
        border: none;
        box-shadow: none;
      }
      .vue-treeselect__menu {
        max-height: none !important;
      }
      .vue-treeselect__checkbox--checked {
        border-color:var(--primary-color);
        background:var(--primary-color);
      }
    }
    .bottom-buttom {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .btn {
        min-width: 100px
      }
      .btn-apply {
        background-color: var(--primary-color) !important;
        color: #fff;
      }
    }
  }

</style>
